import { IconButton, Input, InputAdornment, TextField, Typography, withStyles } from "@material-ui/core";
import { useEffect, useState } from "react"
import BgLeft from '../assets/bgleftPass.svg';
import Bg from '../assets/bgrightPass.svg';
import LogoLogin from '../assets/LogoLogin.png';
import Kunci from '../assets/new_pass.png';
import Username from '../assets/ic_un.png';
import Password from '../assets/ic_pass.png';
import { Visibility, VisibilityOff } from "@material-ui/icons";
import api from './api';
import { useHistory } from "react-router";

const InputBaru = withStyles({
    root: {
        '& .MuiInputBase-input': {
            fontFamily: 'Poppins',
            fontSize: '1.4vh',
            fontWeight: '500',
            boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-input': {
            padding: '2vh 1vh'
        },
    }
})(TextField);

export default function NewPassword(props) {
    const history = useHistory()

    const [showPass, setShowPass] = useState(false)
    const [showPassConf, setShowPassConf] = useState(false)
    const [verificationCode, setVerificationCode] = useState("")
    const [password, setPassword] = useState("")
    const [confPassword, setConfPassword] = useState("")

    useEffect(() => {
        let url = []
        url = String(window.location.href).split("/")
        let uri = url[url.length - 1]
        console.log(uri);
        setVerificationCode(uri)
    }, [])

    const handleSubmit = () => {
        let payload = {
            "verification_code": verificationCode,
            "password": password,
            "password_confirmation": confPassword
        }
        api.create().resetPass(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    history.push('/success-pass')
                } else {
                    if (response.data.data) {
                        if (response.data.data.password) {
                            alert(response.data.data.password)
                        }
                    }
                }
            }
        })
    }

    return (
        <div style={{ height: '100vh', display: 'flex', backgroundColor: '#278863', width: '100%' }}>
            <img src={BgLeft} style={{ position: 'absolute', left: 0, bottom: 0, width: '47%' }} />
            <img src={Bg} style={{ position: 'absolute', right: 0, bottom: 0, width: '30%' }} />
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{ width: '100%', height: '20%', display: 'flex', padding: '2%', justifyContent: 'space-between', paddingLeft: '3%', paddingRight: '3%' }}>
                    <img src={LogoLogin} className="logo-rscc" style={{}} />
                    <button
                        onClick={() => {
                            history.push('/')
                        }}
                        style={{}} className="new-pass-login">
                        <Typography className="text-login" style={{}}>Login </Typography>
                    </button>
                </div>
                <div style={{ width: '100%', height: '80%', display: 'grid', justifyItems: 'center' }}>
                    <div className="div-paper-new-pass" style={{}}>
                        <div style={{ width: '100%', height: '100%', textAlign: 'center', padding: '3%' }}>
                            <img src={Kunci} className="ic-key" />
                            <Typography style={{ color: '#278863', fontSize: '2vw', textAlign: 'center', marginTop: '3%', fontFamily: 'Poppins', fontWeight: '500' }}>Perbarui Kata Sandi </Typography>
                            {/* <div style={{ display: 'grid', width: '100%', justifyItems: "center", marginTop: '2%' }}>
                                <Typography style={{ color: 'black', fontSize: '1vw', textAlign: 'center', width: '50%' }}>Masukan Email atau No. Handphone anda untuk merubah kata sandi !</Typography>
                            </div> */}
                            <div style={{ marginTop: '4%', width: '100%', textAlign: '-webkit-center' }}>
                                <div className="new-pass-input">
                                    <img src={Password} style={{ height: '3vh', width: '8%' }} />
                                    <Input
                                        type={showPass ? 'text' : 'password'}
                                        style={{ width: '75%', height: '50%', fontSize: '1.2vw' }}
                                        disableUnderline={true}
                                        placeholder={'Kata Sandi Baru'}
                                        onChange={(e) => {
                                            setPassword(e.target.value)
                                        }}
                                    >
                                    </Input>
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        style={{ color: '#4b4b4b', opacity: 0.5, outline: 'none', width: '14%' }}
                                        onClick={() => setShowPass(!showPass)}
                                        edge="end"
                                    >
                                        {showPass ? <Visibility style={{ fontSize: '25px' }} /> : <VisibilityOff style={{ fontSize: '25px' }} />}
                                    </IconButton>
                                </div>
                                <div className="new-pass-input" style={{ marginTop: '4%' }}>
                                    <img src={Password} style={{ height: '3vh', width: '8%' }} />
                                    <Input
                                        type={showPassConf ? 'text' : 'password'}
                                        style={{ width: '75%', height: '50%', fontSize: '1.2vw' }}
                                        disableUnderline={true}
                                        placeholder={'Konfirmasi Sandi Baru'}
                                        onChange={(e) => {
                                            setConfPassword(e.target.value)
                                        }}
                                    >
                                    </Input>
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        style={{ color: '#4b4b4b', opacity: 0.5, outline: 'none', width: '14%' }}
                                        onClick={() => setShowPassConf(!showPassConf)}
                                        edge="end"
                                    >
                                        {showPassConf ? <Visibility style={{ fontSize: '25px' }} /> : <VisibilityOff style={{ fontSize: '25px' }} />}
                                    </IconButton>
                                </div>
                                {/* <TextField
                                    // label={<Typography style={{ fontSize: '1vw', fontFamily: 'Poppins' }}>Username (NIK)</Typography>}
                                    id="password"
                                    type={"text"}
                                    name={"password"}
                                    placeholder={'Kata Sandi Baru'}
                                    // value={email}
                                    onChange={(email) => {
                                        // handleChange(email)
                                    }}
                                    variant="outlined"
                                    // error={errorEmail}
                                    style={{ width: '60%', fontSize: '1vw', borderRadius: 30, padding: 0 }}
                                    // helperText={msgEmail}
                                    InputProps={{
                                        style: { borderRadius: '3vh', height: '8%', backgroundColor: 'white', borderColor: '#278863', borderStyle: 'solid', borderWidth: '.4vh', maxHeight: 40, fontSize: '1vw', padding: 0 },
                                        startAdornment: <InputAdornment position="end" style={{ marginRight: '10%', height: '10%' }}><img src={Username} style={{ height: '3vh' }} /></InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            marginLeft: '15%',
                                            padding: 0
                                        }
                                    }}
                                /> */}
                            </div>
                            <div style={{ width: '100%', display: 'grid', justifyItems: 'center' }}>
                                <button
                                    onClick={() => handleSubmit()}
                                    className="new-pass-submit"
                                    style={{ }}>
                                    <Typography className="text-login" style={{textAlign: 'center' }}>Submit </Typography>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}